import { EXTERNAL_URLS } from '@Shared/config';

export const bgVideoUrl =
  'https://stream.mux.com/6O02hQporDSNQ01FQuUJc91pQft00AbB5hs.m3u8';

export const faqListLandingMock = [
  {
    open: false,
    question: 'How much does Pitch59 cost?',
    description:
      'Pitch59 offers four flexible pricing plans designed for individuals, professionals, and organizations of all sizes.',
    listItems: [
      'Starter: Free',
      'Pro: $8.33/month, billed annually',
      'Pro Plus: $12.50/month, billed annually',
      {
        text: 'Enterprise: ',
        link: { label: 'Contact Sales', action: 'contact-sales' }
      }
    ],
    subDescription: {
      link: { label: 'Compare Plans', route: '/pricing' }
    }
  },
  {
    open: false,
    question: 'How do I write my elevator pitch?',
    description:
      'With Pitch59’s AI-powered Elevator Pitch Creator, writing your pitch is simple. The pitch creator asks 5 questions about you, your personality, and your business. Those answers will then be used to create a professional, personalized elevator pitch you can edit at any time.'
  },
  {
    open: false,
    question: 'What is a PitchCard?',
    listItems: [
      'Your Digital Business Card – All your essential contact info, easily saved—no account required.',
      'Your Elevator Pitch - Share your written pitch and ideally add a 59-second video introducing you and your business. Video helps build trust by showcasing your personality while clearly communicating your value.',
      'Your Network - Use Network Pockets to organize and manage connections you make through the PitchCard Carousel, at events, and beyond.',
      'A Networking and Referral Tool - Every PitchCard includes a ready-to-use 3-way introduction message, making it easy for others to introduce you without guessing what to say.',
      '<a class="faq-answer_link" target="_blank" href="https://blog.pitch59.com/pitch59-blog/what-is-a-pitchcard">More</a>'
    ]
  },
  {
    open: false,
    question: 'What are the benefits of becoming an affiliate?',
    description:
      'Becoming an affiliate is free to anyone with a Business PitchCard. There are no hidden fees. As an affiliate:',
    listItems: [
      'You earn 20% monthly residual commissions on all PitchCards that sign up through your promo code (for the life of the PitchCard).',
      'You earn 5% residual commissions on all second-tier sales (any commissions from affiliates signed up under your affiliate code).',
      'Give your network 1 free month on their subscription when they subscribe using your promo code.'
    ]
  },
  {
    open: false,
    question: 'How do I become an affiliate?',
    description:
      'Becoming an affiliate is simple. After creating and personalizing your PitchCard, follow these simple steps',
    listItems: [
      'Log in to your Pitch59 account online.',
      'Click the drop down menu next to your name.',
      'Click on “Affiliate Hub”.',
      'Follow the prompts and fill out the information requested. You will need either a PayPal or Venmo account to receive your payments',
      'Read through and agree to the <a class="faq-answer_link" href="' +
        EXTERNAL_URLS.AFFILIATE_TERMS +
        '" target="_blank">Affiliate Terms and Conditions</a>.',
      'Click "Become an Affiliate".'
    ]
  }
];

export const faqListResumeMock = [
  {
    open: false,
    question: 'What is unique about Pitch59?',
    description:
      'Pitch59 goes far beyond traditional resumes or business cards. It gives you a dynamic, multimedia presence that allows others to truly get to know you, not just your qualifications.<br><br>Here’s what makes it stand out:',
    listItems: [
      '59-Second Elevator Pitch Video: Show your personality and professionalism with a concise video introduction. People hire people, not paper!',
      'Unbiased Search Carousel: All PitchCards are shown in random order, no paid promotions or preferential treatment. Everyone gets a fair shot at being discovered.',
      'Direct Connections: Recruiters and hiring managers can contact you directly skipping tedious processes.',
      'Built-in Testimonials: Coworkers, mentors, or clients can record 59-second video testimonials, giving your card credibility and character.',
      'Personal Branding Tools: Your PitchCard includes a written elevator pitch (crafted with our help if needed), personal info, photos, and even your resume, all in one shareable format.'
    ]
  },
  {
    open: false,
    question: 'How do I use a Resume PitchCard to get a job?',
    description:
      "Think of your Resume PitchCard as a digital handshake. It's not just what you say—it's how you say it. Here's how to use it strategically:",
    listItems: [
      'Link It Everywhere: Add it to your email signature, LinkedIn bio, job applications, and even physical resumes (via QR code).',
      'Send It Directly: Share it via text or social media messages when networking or applying for roles.',
      'Showcase Your Value: Let recruiters see your communication style, confidence, and personality within 59 seconds, often more memorable than just reading a resume.',
      'Leverage Testimonials: Ask mentors or former colleagues to record brief endorsements. This builds instant trust and social proof.',
      "Stay Ready: Update your PitchCard as your skills or goals evolve. It's always ready to work for you, 24/7."
    ]
  },
  {
    open: false,
    question: 'How do I write my elevator pitch?',
    description:
      'Use the HERA model to craft a clear, engaging, and authentic elevator pitch. HERA stands for: Humanize, Empathize, Resolve, Act.',
    specialList: [
      {
        title: 'H – Humanize',
        description:
          'Start by making yourself relatable. Share something unique about your personality, background, experience, or skills that helps people connect with you.',
        examples: [
          "As a first-generation college graduate with a love for systems thinking, I've always been drawn to solving messy operational challenges."
        ]
      },
      {
        title: 'E – Empathize',
        description:
          'Demonstrate you understand your audience\'s challenges. Speak to their "shark bites"—the serious problems keeping them up at night—not just minor annoyances.',
        examples: [
          'I know how frustrating it is when fast-growing teams struggle with broken internal processes and missed deadlines.'
        ]
      },
      {
        title: 'R – Resolve',
        description:
          "Explain how you're qualified to solve the problem, and how you'll go about it. Highlight your experience, approach, and results in simple terms.",
        examples: [
          'In my last role, I restructured our onboarding flow and cut new hire ramp time by 40%. I build systems that scale with people.'
        ]
      },
      {
        title: 'A – Act',
        description:
          'End with a clear call to action or goal. Make it easy for the listener to know what you want next.',
        examples: [
          "I'm looking for my next challenge in operations at a mission-driven startup—let's connect if you're scaling and need help building structure that lasts."
        ]
      }
    ],
    subDescription:
      "This model helps you go beyond a list of accomplishments—you're telling a story that resonates with your audience and shows them why you're the right fit. Want help structuring your pitch inside Pitch59? The app includes a prompt-driven guide to help you write and record your HERA-based pitch in just a few minutes!"
  },
  {
    open: false,
    question: 'What is a Resume PitchCard?',
    description:
      'A Resume PitchCard is your digital first impression, A shareable, digital card that includes:',
    listItems: [
      'Your 59-second elevator pitch video',
      'A written elevator pitch crafted with help from Pitch59',
      'Resume and personal info (job title, contact, links)',
      'Photos or visuals that represent you',
      'Optional video testimonials and endorsements'
    ],
    subDescription:
      "It's like a resume and a video interview rolled into one—and it works for you before you ever walk into a room."
  },
  {
    open: false,
    question: 'How does a Resume PitchCard help me stand out?',
    description:
      'Most job seekers rely on words on a page. A Resume PitchCard adds voice, personality, and presence to your profile.',
    listItems: [
      "You're more than bullet points: Video lets employers see your confidence, enthusiasm, and communication skills in action.",
      'Memorable in a sea of sameness: Your video pitch and visual design make you stand out against stacks of resumes.',
      'Adds credibility: Video testimonials from real people give hiring managers more reasons to trust and connect with you.',
      "Builds emotional connection: Seeing and hearing someone creates a human connection that's hard to replicate with text alone."
    ],
    subDescription:
      "With a Resume PitchCard, you don't just apply for a job—you make a lasting impression."
  }
];

export const demoListMock: string[] = [
  'See the anatomy of a PitchCard',
  'Learn how your PitchCard can get you referrals in seconds',
  'Keep your network in your pockets',
  'Network with new pros everyday'
];
export const performanceIndicatorsMock: any[] = [
  {
    count: '150%',
    title: 'Increase in meetings scheduled',
    subtitle: 'Alta Commercial Capital'
  },
  {
    count: '17',
    title: 'New referrals in the first day',
    subtitle: 'Sales Xceleration'
  },
  {
    count: '$19K',
    title: 'In new business from 1 Referral',
    subtitle: 'AC Ninja'
  }
];
export const adviceListMock = [
  {
    img: 'assets/images/landing/image-analytic.svg',
    title: 'Keep track of analytics',
    description:
      'View helpful metrics like number of times your PitchCard has been shared, who’s sharing it, how they are sharing it, and more!'
  },
  {
    img: 'assets/images/landing/image-network.svg',
    title: 'Success Tips',
    description:
      'View and complete the Success Tips and Challenge to build a strong network and get more referrals.'
  },
  {
    img: 'assets/images/landing/image-noun-pitch-deck.svg',
    title: 'AI Assisted Elevator pitch creator',
    description:
      'Create your elevator pitch by answering 5 simple questions, our AI-enhanced Elevator Pitch Creator will do the rest!'
  }
];

export const adviceListLandingMock = [
  {
    img: 'assets/images/landing/image-analytic.svg',
    title: 'Analytics',
    description:
      'View helpful metrics like number of  times your pitchcard has been shared, who’s sharing it, how they are sharing it, and more!'
  },
  {
    img: 'assets/images/landing/image-tips.svg',
    title: 'Success Tips',
    description:
      'View and complete the Success Tips and Challenge to build a strong network and get more referrals.'
  },
  {
    img: 'assets/images/landing/image-noun-pitch-deck.svg',
    title: 'AI Assisted Elevator pitch creator',
    description:
      'Create your elevator pitch by answering 5 simple questions, our AI-enhanced Elevator Pitch Creator will do the rest!'
  }
];

export const additionalAdviceListMock = [
  {
    img: 'assets/images/landing/icon_share-story.svg',
    title: 'Share Your Story',
    description:
      'Your PitchCard contains your 59-second elevator pitch. Don’t want the video? No problem, just your written only pitch.'
  },
  {
    img: 'assets/images/landing/icon_get-referrals.svg',
    title: 'Get Referrals',
    description:
      'Anyone, with or without the app, can refer and make custom message 3-way introductions for you in less than 10 seconds'
  },
  {
    img: 'assets/images/landing/icon_network.svg',
    title: 'Network with others',
    description:
      'When you have a PitchCard, you can search and  automatically get networked with other PitchCard owners to build your referral partnerships.'
  }
];

export const reviewsListMock = [
  {
    author: 'Orion P.',
    stars: Array(5).fill(''),
    content:
      'Great tool! <b>I wish all my professional contacts had this!</b> It makes sharing who you are and what you do so simple! I love how the Testimonial feature works and I am excited to see the growth as they implement these awesome features to get us all more exposure to one another. <b>Genius idea and I am glad to have it</b>'
  },
  {
    author: 'Jordan P.',
    stars: Array(5).fill(''),
    content:
      'The future of networking <br/> As a college student, nothing is better than a succinct, informational card that you can send to someone many states away, or put on the back of a business card. <b>I’m impressed with what I’ve seen so far</b> and can’t wait to see more!'
  },
  {
    author: 'Daniel B.',
    stars: Array(4).fill(''),
    content:
      'Awesome app! <b>I have never had such an easy time describing how our business helps people!</b> Now I can just show them our 59-second PitchCard, and they can see for themselves. Love it! :)'
  },
  {
    author: '@Afriendlytenant',
    stars: Array(5).fill(''),
    content:
      'Pitch59 is the <b>new way of doing business</b>. It combines power of in-person sales with the reach of online marketing. It allows business owners and organizations to come to life. Additionally, <b>Pitch59 is easy to use, not complicated at all</b>. You know exactly where to touch to complete the task you want to accomplish! <b>10/10 recommend!!!!!!!!!!!!!!!!</b>'
  },
  {
    author: 'Kudu K.',
    stars: Array(5).fill(''),
    content:
      '<b>So easy!</b> It’s the easiest way to connect with others and and make referrals and 3 way introductions. <b>It also makes you look like very professional</b> and tech savvy when someone gives you a paper business card and you give them your Pitch card. I love it!'
  },

  {
    author: 'Will C.',
    stars: Array(5).fill(''),
    content:
      "<b>I live by Pitch59 now</b> and I’m seeing accelerated referrals to my referral partners daily. <b>It makes it easy for others to help me</b> and allows me to tell my elevator pitch on what's important."
  },
  {
    author: '@Dobbershot',
    stars: Array(5).fill(''),
    content:
      '<b>This is what I’ve been waiting for!</b> <br/> I’ve been approached by countless off brands that miss the mark or do half as much. The networking experience Pitch59 provides couldn’t be easier and more effective. They have really created the <b>new must have business tool.</b>'
  },
  {
    author: '@Cougarfan17',
    stars: Array(5).fill(''),
    content:
      '<b>Best tool EVER for increasing sales!</b> <br/> The Pitch59 app makes it is super easy to give and get referrals. I’ve owned several businesses and I spent $800-$3500/mo in lead generation. I don’t know exactly how many of our referrals and sales can be sourced directly to the Pitch59 app, but I can tell you it’s a TON. <b>At $15, I think Pitchcards are the best tool ever invented for growing a business.</b>'
  },
  {
    author: 'Virginia M.',
    stars: Array(5).fill(''),
    content: `I'm really excited about the PitchCards!  It's fabulous! I definitely want to be part of what you are up to. <b>This is one of the sexiest platforms I've seen in a VERY long time!</b>
Can't wait to start promoting it!`
  }
];

export const blogListMock = [
  {
    img: 'assets/images/landing/blog-1.png',
    title: 'Networking: Building Bridges for Business Growth',
    url: EXTERNAL_URLS.BLOG_NETWORKING
  },
  {
    img: 'assets/images/landing/blog-2.png',
    title: 'Unleash the Power of Pitch Videos',
    url: EXTERNAL_URLS.BLOG_UNLEASH_POWER
  },
  {
    img: 'assets/images/landing/blog-3.png',
    title: 'Build Trust, Get Referrals',
    url: EXTERNAL_URLS.BLOG_GETTING_REFERRALS
  }
];
